import { fluidvids } from './fluidvids.js'
import { watchDarkMode } from './dark-mode.js'
import { gallery } from './gallery.js'
import { infiniteScroll } from './infinite.js'

document.addEventListener('DOMContentLoaded', () => {
  watchDarkMode()
  infiniteScroll()
  gallery()
  fluidvids.init({
    selector: ['iframe', 'object'],
    players: ['www.youtube.com', 'player.vimeo.com'],
  })
})
